// extracted by mini-css-extract-plugin
export default {"form":"styles_form__vcG2k","formItem":"styles_formItem__bJKkd","button":"styles_button__bHxSr","icon":"styles_icon__Qr+ea"};